export default "__VITE_ASSET__Edc7r5aQ__"